import {scrolEvents} from './default';
import {vues} from './vues';
import {loading} from './loading';

document.addEventListener('DOMContentLoaded', function() {
	let scene = [];
	let controller;
    controller =  new ScrollMagic.Controller();
	
    vues();
    loading();
	scrolEvents(controller , scene);
    
});